import { render, staticRenderFns } from "./pile-swap-record-table.vue?vue&type=template&id=113eb31a&scoped=true"
import script from "./pile-swap-record-table.vue?vue&type=script&lang=js"
export * from "./pile-swap-record-table.vue?vue&type=script&lang=js"
import style0 from "./pile-swap-record-table.vue?vue&type=style&index=0&id=113eb31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113eb31a",
  null
  
)

export default component.exports